import { PageHeader } from '@core/components/PageHeader';
import { SearchBar } from '@core/components/SearchBar';
import { Button } from '@material-ui/core';
import React, { useContext } from 'react';
import { FaShoppingCart } from 'react-icons/fa';
import { ProdutoContext } from '../../ProdutoContext';
import { produtoModais } from '../modal/produtoModais';
import { ProdutoSearchStyles } from './styles';

const ProdutoSearchHeader = () => {
  const [, setSearch] = useContext(ProdutoContext).search;
  const [, setModal] = useContext(ProdutoContext).modal;

  const styles = ProdutoSearchStyles();

  const handleOpenBuscaAvancada = () => {
    setModal(produtoModais.buscaAvancada);
  };

  return (
    <PageHeader title="Produtos" icon={<FaShoppingCart />}>
      <div className={styles.searchHeaderProduto}>
        <div className="flex items-center w-full max-w-512 stepBarraPesquisa">
          <SearchBar onChange={setSearch} />
        </div>
        <div className="stepBuscaAvancada">
          <Button className={styles.link} onClick={handleOpenBuscaAvancada}>
            Busca avançada
          </Button>
        </div>
      </div>
    </PageHeader>
  );
};

export default ProdutoSearchHeader;
